var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightFromBracketSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M377.9,105.9l122.8,122.8c7.2,7.2,11.3,17.1,11.3,27.3c0,10.2-4.1,20.1-11.3,27.3L377.9,406.1 c-6.4,6.4-15,9.9-24,9.9c-18.7,0-33.9-15.2-33.9-33.9V320H192c-17.7,0-32-14.3-32-32v-64c0-17.7,14.3-32,32-32h128v-62.1 c0-18.7,15.2-33.9,33.9-33.9C362.9,96,371.5,99.6,377.9,105.9z M160,96H96c-17.7,0-32,14.3-32,32v256c0,17.7,14.3,32,32,32h64 c17.7,0,32,14.3,32,32s-14.3,32-32,32H96c-53,0-96-43-96-96V128c0-53,43-96,96-96h64c17.7,0,32,14.3,32,32S177.7,96,160,96z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightFromBracketSolid);
export default __webpack_public_path__ + "static/media/right-from-bracket-solid.125623e4944b5a0d870404ceb3a9316a.svg";
export { ForwardRef as ReactComponent };